import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './api';
import { BASE_URL } from '../keys';
export const currencyApi = createApi({
      reducerPath: "currencyApi",
  baseQuery: axiosBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
 getCurrencyList: builder.query({
      query: () => ({
        url: `client/list-currencies/`,
        // headers: {
        //   Authorization: "Bearer " + localStorage.getItem('livtoken')
        // },
      }),
    }),
   getPrice: builder.query({
      query: ({ categoryId }) => {
        const currency = JSON.parse(localStorage.getItem("currency") || "{}");
        return {
          url: `client/get-price/?category_id=${categoryId}&currency_id=${currency?.id}`
          // headers: {
          //   Authorization: "Bearer " + localStorage.getItem('livtoken')
          // },
        };
      },
    }),
  })
})
export const {
useGetCurrencyListQuery,useGetPriceQuery} = currencyApi;